import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TagList from '../tag/TagList';
import Tag from '../tag/Tag';
var TagManagerItemList = function TagManagerItemList(props) {
  var tags = props.tags,
    onRemoveFromTagList = props.onRemoveFromTagList;
  return /*#__PURE__*/React.createElement(TagList, {
    inline: false
  }, tags.map(function (tag) {
    var tagClasses = classNames(tag.toAdd && 'border-color-success text-color-success', tag.toRemove && 'border-color-danger text-color-danger');
    return /*#__PURE__*/React.createElement(Tag, {
      key: tag.label,
      className: tagClasses,
      deletable: true,
      round: false,
      onClick: function onClick() {
        return onRemoveFromTagList(tag);
      }
    }, tag.label);
  }));
};
TagManagerItemList.defaultProps = {};
TagManagerItemList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    toAdd: PropTypes.bool,
    toRemove: PropTypes.bool
  })),
  onRemoveFromTagList: PropTypes.func
};
export default TagManagerItemList;